var _defs, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.01,
    height: 73.01,
    viewBox: "0 0 73.01 73.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #c6c6c5;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #c6c6c5;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39,36.13H27.44l0,3.3h7.77c-.92,4-3.76,6.49-7.56,6.49a9,9,0,1,1,6.14-15.67l2.55-2.2a12.39,12.39,0,1,0-8.69,21.22c6.57,0,11.32-5,11.32-11.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.53 36.27 50.77 36.27 50.77 31.51 47.74 31.51 47.74 36.27 42.98 36.27 42.98 39.3 47.74 39.3 47.74 44.06 50.77 44.06 50.77 39.3 55.53 39.3 55.53 36.27"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.5,
    cy: 37.26,
    r: 35.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIconShare);
export default __webpack_public_path__ + "static/media/google-icon-share.1ff565dcb0a94adaf9c53ab022e2d64f.svg";
export { ForwardRef as ReactComponent };